import { clerkAuthHeaders } from './clerkApiAuth';
import { CareerPosting, CareerWrite } from '../types/career';

const API_BASE_URL = '/api';

async function errorMessage(response: Response, fallback: string): Promise<string> {
  try {
    const body = await response.json();
    if (typeof body?.error === 'string' && body.error.trim()) return body.error;
  } catch {
    // The body was not JSON.
  }
  return fallback;
}

export const careerAPI = {
  async fetchPostings(): Promise<CareerPosting[]> {
    const response = await fetch(`${API_BASE_URL}/careers`);
    if (!response.ok) throw new Error(await errorMessage(response, 'Failed to load careers'));
    return response.json();
  },

  async fetchStaffPostings(): Promise<CareerPosting[]> {
    const response = await fetch(`${API_BASE_URL}/careers?includeDrafts=true`, {
      headers: await clerkAuthHeaders({ json: false }),
    });
    if (!response.ok) throw new Error(await errorMessage(response, 'Failed to load careers'));
    return response.json();
  },

  async fetchPosting(id: string): Promise<CareerPosting> {
    const response = await fetch(`${API_BASE_URL}/careers/${encodeURIComponent(id)}`, {
      headers: await clerkAuthHeaders({ json: false }),
    });
    if (!response.ok) throw new Error(await errorMessage(response, 'Posting not found'));
    return response.json();
  },

  async createPosting(input: CareerWrite): Promise<{ id: string }> {
    const response = await fetch(`${API_BASE_URL}/careers`, {
      method: 'POST',
      headers: await clerkAuthHeaders(),
      body: JSON.stringify(input),
    });
    if (!response.ok) throw new Error(await errorMessage(response, 'Failed to save posting'));
    return response.json();
  },

  async updatePosting(id: string, input: CareerWrite): Promise<CareerPosting> {
    const response = await fetch(`${API_BASE_URL}/careers/${encodeURIComponent(id)}`, {
      method: 'PUT',
      headers: await clerkAuthHeaders(),
      body: JSON.stringify(input),
    });
    if (!response.ok) throw new Error(await errorMessage(response, 'Failed to save posting'));
    return response.json();
  },

  async deletePosting(id: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/careers/${encodeURIComponent(id)}`, {
      method: 'DELETE',
      headers: await clerkAuthHeaders({ json: false }),
    });
    if (!response.ok) throw new Error(await errorMessage(response, 'Failed to delete posting'));
  },
};
